module.exports = __webpack_public_path__ + "static/img/suanfas_img5.ad10197c.jpg";